export default __webpack_public_path__ + "static/media/argon-react-white.32156a42.png";